export const getArchiveUrl = (sectionUrl, year, month) =>
  `${sectionUrl}/archive/${year}/${month}`;
